export const API_URL = 'https://golivegameplan.com/api/v1';
// export const API_URL = 'http://localhost:5000/api/v1';
// export const API_URL = 'https://5510-202-8-113-39.in.ngrok.io/api/v1';
